import { CheckIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LOCALE_LABELS, SUPPORTED_LOCALES } from "@/lib/i18n/config";
import { useAppStore } from "@/stores/useApp";
import { cn } from "@/lib/utils";

const LanguageSelector = ({ onSelect }: { onSelect?: () => void }) => {
  // i18next already holds the resolved locale (persisted choice or detection),
  // so reading it here keeps one source of truth for "what is showing".
  const { t, i18n } = useTranslation();
  const setLocale = useAppStore((s) => s.setLocale);
  const active = i18n.resolvedLanguage;

  return (
    <div data-test-id="language-section" className="mb-8 flex flex-col gap-4">
      <h3 className="font-semibold">{t("menu_language_header")}</h3>
      <ul className="flex flex-col">
        {SUPPORTED_LOCALES.map((locale) => (
          <li key={locale}>
            <button
              type="button"
              data-test-id={`language-option-${locale}`}
              onClick={() => {
                setLocale(locale);
                onSelect?.();
              }}
              className={cn(
                "text-neutral-30 flex w-full items-center justify-between py-2 text-left transition-colors hover:text-white",
                locale === active && "font-semibold text-white",
              )}
            >
              <span>{LOCALE_LABELS[locale]}</span>
              {locale === active && <CheckIcon className="size-4" />}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LanguageSelector;
